import Alert from "react-bootstrap/Alert";

export default Alert;
